import Vue from 'vue'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import App from './App.vue'
import router from './router'
import '@/assets/font/fonts.css'
import MetaInfo from 'vue-meta-info'
Vue.config.productionTip = false
Vue.use(ElementUI);
Vue.use(MetaInfo);
new Vue({
  router,
  render: h => h(App),
  mounted () {
  	document.dispatchEvent(new Event('render-event'))
  }
}).$mount('#app')
